/**
 * AdminTopbar — Merchant Topbar'ın birebir aynı yapısı + sağ-üstte sabit
 * "SÜPER ADMİN" chip'i. Merchant'ta aynı alan paket bilgisi için
 * ayrılmıştı; şimdi admin modunda bu alan rolü değiştirmemiş gibi
 * görünür ama içerik admin rozetidir.
 */
import { useLocation } from "react-router-dom";
import { ShieldCheck } from "lucide-react";

const routeTitles = {
    "/sayz-super-admin/overview": "Hesaplar",
};

export default function AdminTopbar() {
    const loc = useLocation();
    const title = routeTitles[loc.pathname] || "Süper Admin";

    return (
        <header
            className="sticky top-0 z-30 h-16 border-b border-border glass"
            data-testid="admin-topbar"
        >
            <div className="h-full flex items-stretch">
                <div className="flex-1 flex items-center px-5 md:px-7 min-w-0">
                    <span
                        className="font-display text-[15px] font-semibold tracking-tight truncate"
                        data-testid="admin-topbar-title"
                    >
                        {title}
                    </span>
                </div>
                <div className="flex items-center px-5 md:px-7">
                    <span
                        className="inline-flex items-center gap-1.5 rounded-md px-2.5 py-1 text-[11px] font-semibold tracking-wide uppercase bg-foreground text-background"
                        data-testid="admin-topbar-badge"
                    >
                        <ShieldCheck className="h-3 w-3" strokeWidth={2.5} />
                        Süper Admin
                    </span>
                </div>
            </div>
        </header>
    );
}
